export default{
	"Российская Федерация": "Российская Федерация",
	"агинский бурятский ао": "Агинский бурятский AO",
	"алтайский край": "Алтайский край",
	"амурская область": "Амурская область",
	"архангельская область": "Архангельская область",
	"астраханская область": "Астраханская область",
	"белгородская область": "Белгородская область",
	"брянская область": "Брянская область",
	"владимирская область": "Владимирская область",
	"волгоградская область": "Волгоградская область",
	"вологодская область": "Вологодская область",
	"воронежская область": "Воронежская область",
	"город москва": "город  Москва",
	"город санкт-петербург": "город Санкт-Петербург",
	"город севастополь": "город Севастополь",
	"дальневосточный федеральный округ": "Дальневосточный ФО",
	"еврейская автономная область": "Еврейская автономная область",
	"еврейская ао": "Еврейская AO",
	"забайкальский край": "Забайкальский край",
	"ивановская область": "Ивановская область",
	"иркутская область": "Иркутская область",
	"кабардино-балкарская республика": "Кабардино-Балкарская республика",
	"калининградская область": "Калининградская область",
	"калужская область": "Калужская область",
	"камчатская область": "Камчатская область",
	"камчатский край": "Камчатский край",
	"карачаево-черкесская республика": "Карачаево-Черкесская республика",
	"кемеровская область": "Кемеровская область",
	"кировская область": "Кировская область",
	"коми-пермяцкий ао": "Коми-Пермяцкий АО",
	"корякский ао": "Корякский АО",
	"костромская область": "Костромская область",
	"краснодарский край": "Краснодарский край",
	"красноярский край": "Красноярский край",
	"крымский федеральный округ": "Крымский ФО",
	"курганская область": "Курганская область",
	"курская область": "Курская область",
	"ленинградская область": "Ленинградская область",
	"липецкая область": "Липецкая область",
	"магаданская область": "Магаданская область",
	"московская область": "Московская область",
	"мурманская область": "Мурманская область",
	"ненецкий ао": "Ненецкий АО",
	"нижегородская область": "Нижегородская область",
	"новгородская область": "Новгородская область",
	"новосибирская область": "Новосибирская область",
	"омская область": "Омская область",
	"оренбургская область": "Оренбургская область",
	"орловская область": "Орловская область",
	"пензенская область": "Пензенская область",
	"пермская область": "Пермская область",
	"пермский край": "Пермский край",
	"приволжский федеральный округ": "Приволжский ФО",
	"приморский край": "Приморский край",
	"псковская область": "Псковская область",
	"республика адыгея": "республика Адыгея",
	"республика алтай": "республика Алтай",
	"республика башкортостан": "республика Башкортостан",
	"республика бурятия": "республика Бурятия",
	"республика дагестан": "республика Дагестан",
	"республика ингушетия": "республика Ингушетия",
	"республика калмыкия": "республика Калмыкия",
	"республика карелия": "республика Карелия",
	"республика коми": "республика Коми",
	"республика крым": "республика Крым",
	"республика марий-эл": "республика Марий-Эл",
	"республика мордовия": "республика Мордовия",
	"республика саха (якутия)": "республика Саха (Якутия)",
	"республика северная осетия-алания": "республика Северная Осетия-Алания",
	"республика татарстан": "республика Татарстан",
	"республика тыва": "республика Тыва",
	"республика хакасия": "республика Хакасия",
	"ростовская область": "Ростовская область",
	"рязанская область": "Рязанская область",
	"самарская область": "Самарская область",
	"саратовская область": "Саратовская область",
	"сахалинская область": "Сахалинская область",
	"свердловская область": "Свердловская область",
	"северо-западный федеральный округ": "Северо-Западный ФО",
	"северо-кавказский федеральный округ": "Северо-Кавказский ФО",
	"сибирский федеральный округ": "Сибирский ФО",
	"смоленская область": "Смоленская область",
	"ставропольский край": "Ставропольский край",
	"таймырский ао": "Таймырский  АО",
	"тамбовская область": "Тамбовская область",
	"тверская область": "Тверская область",
	"томская область": "Томская область",
	"тульская область": "Тульская область",
	"тюменская область": "Тюменская область",
	"удмуртская республика": "Удмуртская республика",
	"ульяновская область": "Ульяновская область",
	"уральский федеральный округ": "Уральский ФО",
	"усть-ордынский бурятский ао": "Усть-Ордынский Бурятский АО",
	"хабаровский край": "Хабаровский край",
	"ханты-мансийский ао - югра": "Ханты-Мансийский АО - Югра",
	"центральный федеральный округ": "Центральный ФО",
	"челябинская область": "Челябинская область",
	"чеченская республика": "Чеченская республика",
	"читинская область": "Читинская область",
	"чувашская республика": "Чувашская республика",
	"чукотский ао": "Чукотский АО",
	"эвенкийский ао": "Эвенкийский АО",
	"южный федеральный округ": "Южный ФО",
	"ямало-hенецкий ао": "Ямало-Ненецкий АО",
	"ярославская область": "Ярославская область"
}